import script from "./NewCarPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NewCarPage.vue?vue&type=script&setup=true&lang=js"

import "./NewCarPage.vue?vue&type=style&index=0&id=a80bc28a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a80bc28a"]])

export default __exports__